/**
 * Patches the theme's <count-down> custom element (defined in theme.js)
 * to support an evergreen/looping countdown: when an element carries a
 * data-loop-hours attribute, the timer keeps resetting itself forward by
 * that many hours every time it would otherwise hit zero, instead of
 * stopping. Elements without data-loop-hours are completely unaffected.
 */
(function () {
  function patch() {
    var Ctor = customElements.get('count-down');
    if (!Ctor || Ctor.__loopPatched) return;

    var originalCalc = Ctor.prototype.calculateTimeRemaining;

    Ctor.prototype.calculateTimeRemaining = function () {
      var loopHours = parseFloat(this.getAttribute('data-loop-hours'));
      if (loopHours > 0 && this.endTime != null) {
        var durationMs = loopHours * 60 * 60 * 1000;
        var now = Date.now();
        while (this.endTime <= now) {
          this.endTime += durationMs;
        }
      }
      return originalCalc.call(this);
    };

    Ctor.__loopPatched = true;
  }

  if (customElements.get('count-down')) {
    patch();
  } else {
    customElements.whenDefined('count-down').then(patch);
  }
})();
